export default "__VITE_ASSET__COxAAENW__"